export default __webpack_public_path__ + "static/media/group-tutorial.000aebd1.png";